'use strict';

var _    = require('underscore');
var $    = require('jquery');
var Core = require('../core/core.js');
var LibraryRow = require('./library__row.js');
var Icons = require('../../../ui-icons/releases/bundle/rounded-bold-icons-bundle.js');

/**
 * Creates a LibrarySection
 *
 * @class
 */

class LibrarySection extends Core {

    _defaults() {
        return {
            target: '',
            fields: {
                "title": "Title",
                "asset_count": 0
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
                <div class='editor__library__section'>
                    <div class='editor__library__section__header'>
                        <div class='editor__library__section__collapseicon'>
                            <a class='editor__library__section__collapseicon__link'><%= embedded_svg('dropdown-triangle') %></a>
                        </div>
                        <div class='editor__library__section__text'><%- title %></div>
                        <div class='editor__library__section__count'>
                            <span>[</span>
                            <div class='editor__library__section__count__text'><%- asset_count %></div>
                            <span>]</span>
                        </div>
                    </div>
                    <div class='editor__library__section__content'></div>
                </div>
        `;

        super.render();

        this._initDOMEvents();
    }

    _initDOMEvents() {
        //add event listeners
        $('.editor__library__section__collapseicon', this.$el).on('click', this._toggleOpenClose.bind(this));
    }

    clear(){
        //clear content in each section
        $('.editor__library__section__content').empty();
    }

    /**
     * Update asset count number in view
     * @param  {number} newCount Count
     */
    updateAssetCount(newCount) {
        //in asset libray section header
        var renderTarget2 = $('.editor__library__section__count__text', this.$el);
        if(renderTarget2.length > 0) {
            renderTarget2.text(newCount);
        }
    }

    addRow(asset){
        return new LibraryRow({
            target: $('.editor__library__section__content', this.$el),
            fields: {
                'name': asset.name,
                'icon': asset.icon,
                'summary': asset.summary,
                'type': asset.type,
                'has_children': asset.has_children,
                'id': asset.id,
                'version_number': asset.version_number,
                'version_name': asset.version_name,
                'user_name': asset.user_name,
                'date_created': asset.date_created,
                'thumb_url': asset.thumbnail,
                'open_with_doubleclick': asset.open_with_doubleclick
            }
        });
    }

    _toggleOpenClose(e) {
        var toggleDuration = 400;
        var $content = $('.editor__library__section__content', this.$el);
        var $sectionCollapseIcon = $('.editor__library__section__collapseicon', this.$el);

        $content.slideToggle(toggleDuration);
        $sectionCollapseIcon.toggleClass("editor__library__section__collapseicon--closed");
    }

    _close(){
        //hide content
        $('.editor__library__section__content', this.$el).hide();

        //rotate collapse icons
        $('.editor__library__section__collapseicon', this.$el).addClass("editor__library__section__collapseicon--closed");
    }

    addSortedAssetRowDOMs(domList) {
        //parent asset section
        var content = $('.editor__library__section__content', this.$el);

        //add sorted doms to the parent section
        content.append(domList);
    }
}

module.exports = LibrarySection;